import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { Partner } from '@marageti/z4-sdk/lib/travel';
import AgentsView from './agents-view';
import { getMatchingUser } from '../../../utils/auth';
import { compareNames } from '../../../utils/helpers';

const AgentsContainer = () => {
  const { partnerId } = useParams();
  const apiClient = useApiClient();
  const { data: partner, error: partnerError, isLoading: partnerLoading } = useFetch<Partner>(apiClient.partnersClient.getPartner, [partnerId], !!partnerId);

  const agents = partner?.agents?.sort(compareNames) || [];
  const filteredList = agents.filter((agent) => getMatchingUser(agent.email, agent.userInfo)?.status !== 'DISABLED');

  const [showDisabled, setShowDisabled] = useState(false);
  const [inviteOpen, setInviteOpen] = useState(false);

  const toggleShowDisabled = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShowDisabled(e.target.checked);
  };

  const handleCloseInvite = () => setInviteOpen(false);

  const handleOpenInvite = () => setInviteOpen(true);

  return (
    <AgentsView
      agents={showDisabled ? agents : filteredList}
      error={partnerError}
      inviteOpen={inviteOpen}
      onCloseInvite={handleCloseInvite}
      onOpenInvite={handleOpenInvite}
      showDisabled={showDisabled}
      toggleShowDisabled={toggleShowDisabled}
      loading={partnerLoading}
    />
  );
};

export default AgentsContainer;
